import { render, staticRenderFns } from "./FrontpageMain.vue?vue&type=template&id=8489a198&"
import script from "./FrontpageMain.vue?vue&type=script&lang=js&"
export * from "./FrontpageMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports